module.exports = __webpack_public_path__ + "static/media/hexagon-bg.27fd8efc.png";